/* Every place Ari can send someone. `view` values are the dashboard's internal
   activeView ids; `path` is the route. Keys are what the model emits as
   [[goto:key]] - keep this list and the backend's list in step. */
export const ARI_DESTINATIONS = {
  dashboard: { label: 'Dashboard', path: '/dashboard', view: 'dashboard' },
  discover: { label: 'Discover Charities', path: '/dashboard', view: 'discover' },
  campaigns: { label: 'My Campaigns', path: '/dashboard', view: 'campaigns' },
  donations: { label: 'Donations', path: '/dashboard', view: 'donations-mgmt' },
  'thank-yous': { label: 'Thank-Yous', path: '/dashboard', view: 'charity-notes' },
  matching: { label: 'Matching Gifts', path: '/dashboard', view: 'matching' },
  payroll: { label: 'Payroll Giving', path: '/dashboard', view: 'payroll' },
  budget: { label: 'Budget', path: '/dashboard', view: 'budget' },
  team: { label: 'Team Members', path: '/dashboard', view: 'team' },
  volunteer: { label: 'Volunteering', path: '/dashboard', view: 'volunteer' },
  rewards: { label: 'Rewards', path: '/dashboard', view: 'gamification' },
  hr: { label: 'HR Integrations', path: '/dashboard', view: 'hr' },
  reports: { label: 'Reports', path: '/dashboard', view: 'reports' },
  marketing: { label: 'Marketing Tools', path: '/marketing', view: null },
  'site-builder': { label: 'Site Builder', path: '/builder', view: null },
  'company-info': { label: 'Company Info', path: '/dashboard', view: 'settings-company' },
  branding: { label: 'Branding & CSR', path: '/dashboard', view: 'settings-branding' },
  'impact-portal': { label: 'Impact Portal settings', path: '/dashboard', view: 'settings-portal' },
  'white-label': { label: 'White Label', path: '/dashboard', view: 'settings-domain' },
  subscription: { label: 'Subscription', path: '/dashboard', view: 'subscription' },
  'all-campaigns': { label: 'All Campaigns', path: '/campaigns/all', view: null },
  'browse-charities': { label: 'Browse Charities', path: '/charities/browse', view: null },
  analytics: { label: 'Analytics', path: '/analytics', view: null },
};

const GOTO = /\[\[goto:\s*([a-z-]+)\s*\]\]/gi;

/* Pulls [[goto:key]] markers out of a reply and returns the clean text plus
   the destinations Ari offered. Unknown keys are dropped rather than shown
   as a dead button. */
export const extractDestinations = (text) => {
  const keys = [];
  let match;
  GOTO.lastIndex = 0;
  while ((match = GOTO.exec(text)) !== null) {
    const key = match[1].toLowerCase();
    if (ARI_DESTINATIONS[key] && !keys.includes(key)) keys.push(key);
  }
  return {
    content: text.replace(GOTO, '').replace(/[ \t]+\n/g, '\n').trim(),
    destinations: keys.map((k) => ({ key: k, ...ARI_DESTINATIONS[k] })),
  };
};
